import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import moment from 'moment'

import Checkbox from 'components/input/checkbox'

import InputStandard from 'components/input/standard'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import DateContainer from 'components/date-container/date-container'

import { 
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
    setTaskRecurrence
} from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import SmoothCollapse from 'react-smooth-collapse'

class ModalRecur extends Component {
    constructor(props){
        super(props)

        const {
            task
        } = this.props.data

        this.state = {
            id: task.id,
            recurring_incrementer: task.recurring_incrementer ? task.recurring_incrementer : 1,
            recurring_unit: task.recurring_unit ? task.recurring_unit : 2,
            is_recurring: !!task.is_recurring,
            recurring_anchor_date: task.recurring_anchor_date ? task.recurring_anchor_date : new Date(),
            datePickerVisible: false
        }
    }    
	
	componentDidMount = _ => { 
    	setTimeout(_ => { 
			if(this.announcementRef){
				this.announcementRef.inputRef.focus()
			}
        }, 1)
	}

	handleSubmit = _ => {
		const {
            handleError,
            setTaskRecurrence,
            closeCallback
        } = this.props

        const {
            recurring_incrementer
        } = this.state

        const unitNumber = parseInt(recurring_incrementer)

        if(isNaN(unitNumber) || !unitNumber){
            return handleError(`You'll need to enter a unit.`)
        }

        const taskData = {
            ...this.state
        }

        delete taskData.datePickerVisible

        setTaskRecurrence(taskData)
        closeCallback()
	}

	handleChange = (type, value) => {
        this.setState({
            [type]: value
        })
    }

    toggleActive = _ => {
        this.setState({
            is_recurring: !this.state.is_recurring
        })
    }

    toggleDatePicker = _ => {
        this.setState({
            datePickerVisible: !this.state.datePickerVisible
        })
    }

    handleDateChange = recurring_anchor_date => {
        this.setState({
            recurring_anchor_date
        })
    }

	render() {		
		const {
            closeCallback,
            validateResponse,
            handleDismiss,
            data
        } = this.props

        const {
            recurring_unit,
            recurring_incrementer,
            is_recurring,
            recurring_anchor_date,
            datePickerVisible
        } = this.state

		return(
			<div>
				<div className={'borders'}>
                    <h3>
                        { data && data.task ? '"'+data.task.name+'"' : "" }
                    </h3>
                    <label>
                        <Checkbox 
                            isChecked={is_recurring} 
                            onChange={this.toggleActive} 
                        />
                        { is_recurring ? 'Recur this task every:' : 'Recur this task?' }
                    </label>
                    <SmoothCollapse 
                        expanded={is_recurring}
                        allowOverflowWhenOpen={true}
                        heightTransition="0.15s ease"
                        className="smooth-collapse"
                    >
                        <InputStandard
                            placeholder={`1`}
                            ref={ref => this.announcementRef = ref }
                            name="title"
                            onChange={e => this.handleChange('recurring_incrementer', e.target.value)}
                            value={recurring_incrementer}
                        />
                        <DropdownMenu 
                            isObjects={true} 
                            selectableItems={[
                                {
                                    id: 1,
                                    name: recurring_incrementer != 1 ? 'days' : 'day'
                                },{
                                    id: 2,
                                    name: recurring_incrementer != 1 ? 'weeks' : 'week'
                                },{
                                    id: 3,
                                    name: recurring_incrementer != 1 ? 'months' : 'month'
                                }
                            ]} 
                            selectedItemId={recurring_unit} 
                            handleChange={e => this.handleChange('recurring_unit', e)} 
                            parentType="recurring_incrementer" 
                        />
                        <label>
                            Start date:
                        </label>
                        <DateContainer
                            isEdit={true}
                            isOpen={datePickerVisible}
                            toggleCallback={this.toggleDatePicker}
                            selectCallback={this.handleDateChange}
                            initialMonth={new Date()}
                            selectedDate={recurring_anchor_date}
                            showTodayInLabel={true}
                            closeCallback={this.toggleDatePicker}
                        />
                        <div>
                            <ValidateResponse 
                                dismissCallback={handleDismiss} 
                                response={validateResponse} 
                            />
                        </div>
                    </SmoothCollapse>
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Save'} 
					icon={'check'}
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {  
  return {
    accountData: getCurrentAccount(state),
	userData: getCurrentUser(state),
  }
}

const ModalRecurWithValidateResponse = withValidateResponse(ModalRecur)

export default connect(mapStateToProps, {
    setTaskRecurrence
})(ModalRecurWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-recur.jsx